var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"size":"sm","variant":"info","title":_vm.showToolTip ? 'Установить пароль' : ''},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('i',{staticClass:"fa fa-key"})])
}
var staticRenderFns = []

export { render, staticRenderFns }